import * as React from 'react'
import styled from 'styled-components'
import { Link } from '../Link'
import { Container } from '../Container'
import { Logotype } from '../Logotype'
import { SPACE } from '../../styles/constants'
import { calcFontScale } from '../../styles/calcFontScale'
import { injectIntl, InjectedIntlProps, defineMessages } from 'react-intl'
import { withProps } from '../../styles/themed-components'

const messages = defineMessages({
  signIn: {
    id: 'header.sign_in',
    defaultMessage: 'Sign in',
  },
})

interface Props {
  isDumb?: boolean
}

const HeaderWrapped: React.SFC<Props & InjectedIntlProps> = ({ isDumb, intl }) => (
  <Wrapper>
    <Inner isDumb={isDumb}>
      <Link to={`/`}>
        <Logotype width={82.9} height={23.7} />
      </Link>
      {!isDumb && <SignInLink to="/signin">{intl.formatMessage(messages.signIn)}</SignInLink>}
    </Inner>
  </Wrapper>
)

const Wrapper = styled.div``
const InnerWrapped = Container.extend`
  align-items: center;
  display: flex;
  justify-content: ${(props: Props) => (props.isDumb ? 'center' : 'space-between')};
  ${SPACE.inset.s};
`.withComponent('nav')

const Inner = withProps<Props>()(styled(InnerWrapped))`
`

const SignInLink = styled(Link)`
  ${calcFontScale(-0.25)};
`

export default injectIntl(HeaderWrapped)



// WEBPACK FOOTER //
// ./src/components/Header/index.tsx